import React, { useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import CompaniesPreviewModal from './CompaniesPreviewModal';
import SalesTiersChart from './charts/SalesTiersChart';
import PaymentsRatioTiersChart from './charts/PaymentsRatioTiersChart';

const { RangePicker } = DatePicker;

const startDate = dayjs().subtract(5, 'months').startOf('month');
const endDate = dayjs().endOf('month');

export default function CustomerHealthTab({ selectedManagers, renderManagerSelect }) {
  const [monthRange, setMonthRange] = useState([startDate, endDate]);
  const [companiesModalOpen, setCompaniesModalOpen] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [companiesPreviewParams, setCompaniesPreviewParams] = useState(null);

  const onChartBartSelect = (data) => {
    setSelectedCompanies(data.companyIds);
    setSelectedPeriod(data.period);
    setCompaniesPreviewParams(data.additionalParams || null);
    setCompaniesModalOpen(true);
  };

  return (
    <>
      <RangePicker
        picker="month"
        value={monthRange}
        onChange={(dates) => setMonthRange(dates)}
        disabledDate={(current) => current && current > dayjs().endOf('month')}
      />
      {renderManagerSelect()}
      <SalesTiersChart monthRange={monthRange} salesManagers={selectedManagers} onBarSelect={onChartBartSelect} />
      <PaymentsRatioTiersChart
        monthRange={monthRange}
        salesManagers={selectedManagers}
        onBarSelect={onChartBartSelect}
      />
      <CompaniesPreviewModal
        companyIds={selectedCompanies}
        period={selectedPeriod}
        open={companiesModalOpen}
        additionalParams={companiesPreviewParams}
        onClose={() => setCompaniesModalOpen(false)}
      />
    </>
  );
}
